import { Breadcrumb, BreadCrumbItemProps } from '@arco-design/web-react';
import React from 'react';
import styled, { css } from 'styled-components';

export interface BreadcrumbNavItemProps extends BreadCrumbItemProps {
  /** 唯一标识 */
  key?: string;
  /** 面包屑导航项标签展示的内容 */
  label?: React.ReactNode;
  /** 是否隐藏 */
  hidden?: boolean;
  /** 点击事件 */
  onClick?: () => void;
}

interface BreadcrumbNavProps {
  /** 面包屑导航项 */
  items: BreadcrumbNavItemProps[];
  /** 面包屑导航项 样式 */
  style?: React.CSSProperties;
}

export function BreadcrumbNav({ items, style }: BreadcrumbNavProps) {
  const len = items?.length || 0;

  if (len === 0) {
    return null;
  }
  return (
    <Breadcrumb style={{ ...style }}>
      {items
        .filter((item) => !item.hidden)
        .map((item, index) => {
          const { key, label, onClick, ...breadcrumbItemProps } = item;
          const showCssPointer =
            (len > 1 && index !== len - 1) || len === 1 || typeof onClick === 'function';

          return (
            <BreadcrumbItem
              key={key || index}
              $showPointer={showCssPointer}
              onClick={onClick}
              {...breadcrumbItemProps}
            >
              {label}
            </BreadcrumbItem>
          );
        })}
    </Breadcrumb>
  );
}

const BreadcrumbItem = styled(Breadcrumb.Item)<{ $showPointer?: boolean }>`
  &:hover {
    ${({ $showPointer }) =>
      $showPointer &&
      css`
        cursor: pointer;
        color: rgb(var(--primary-6));
        background-color: var(--color-fill-2);
        border-radius: 4px;
      `}
  }
`;
